export enum SubscriptionDurationType
{
    testing="testing",
    freeTrial="freeTrial",
    oneMonth="oneMonth",
    sixMonths="sixMonths"
}